import styled from 'styled-components';

export const Root = styled.div`
  width: 100%;
  display: flex;
  gap: 32px;
  flex-direction: column;
  align-items: center;
`;
